// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BACK_TO_STROLLERS_HOMEPAGE = "Sp\u00e4\u0165 na ko\u010d\u00edkop\u00e9diu";
export const STROLLER_ADD_QUESTION = "Op\u00fdtaj sa v poradni";
export const STROLLER_AT_OFFICIAL_PAGE_OF_name = "ofici\u00e1lnej str\u00e1nke %(name)s";
export const STROLLER_DETAIL_ARTICLES_WITH_stroller = "\u010cl\u00e1nky s %(stroller)s";
export const STROLLER_DETAIL_DESCRIPTION = "Popis ko\u010d\u00edka";
export const STROLLER_DETAIL_LINKED_OBJECTS = "Poradne a diskusie";
export const STROLLER_DETAIL_MORE_ARTICLES_WITH_stroller = "\u010eal\u0161ie \u010dl\u00e1nky s %(stroller)s";
export const STROLLER_DETAIL_SHOW_AVAILABLE_VARIANTS = "Zobrazi\u0165 dostupn\u00e9 varianty";
export const STROLLER_FEATURES = "Parametre";
export const STROLLER_HAS_BEEN_DELETED = "Tento ko\u010d\u00edk bol zmazan\u00fd";
export const STROLLER_MORE_DESCRIPTION = "Zobraz cel\u00fd popis";
export const STROLLER_MORE_INFO_AT_link = "Viac inform\u00e1ci\u00ed na %(link)s";
export const STROLLERS_DETAILED_REVIEW = "Podrobn\u00e1 recenzia";
export const STROLLERS_DETAIL_MORE_STROLLERS_OF_THIS_brand = "\u010eal\u0161ie ko\u010d\u00edky %(brand)s";
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
export const STROLLER_UNPREPARED_TAG = "Pripravujeme";
